<template>
  <div class="container-custom">
    <!-- breadscrumbs -->
    <Breadscrumbs
      :links="[
        {
          name: 'BU Page',
          to: {
            name: 'BUPage'
          }
        },
        {
          name: 'Edit',
          to: {
            name: 'BUPageEdit',
            params: {
              id: $route.params.id,
            },
            query: {
              section: $route.query.section,
            },
          }
        }
      ]"
    ></Breadscrumbs>
    <BUPAgeCreateEdit v-if="bu"></BUPAgeCreateEdit>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import BUPAgeCreateEdit from '@/views/B-3__BUPage/c/BUPageCreateEdit.vue';
import Breadscrumbs from '@/components/Breadscrumbs.vue';

export default {
  components: {
    BUPAgeCreateEdit,
    Breadscrumbs,
  },
  computed: {
    ...mapState('bupage', ['bu']),
  },
  async created() {
    if (this.bu === null && this.$route.params.id) {
      await this.getBu(this.$route.params.id);
    }
  },
  methods: {
    ...mapActions('bupage', {
      getBu: 'findById',
    }),
  },
};
</script>

<style></style>
